import { otsBaseApi } from "../../ots-api";
import { Route } from "../../../model/route";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({ addTagTypes: ["Routes"] });

const routeApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllRoutes: builder.query<Route[], string | undefined>({
      query: (regionId) => ({
        url: `/routes/all`,
        method: "GET",
        params: buildParams(regionId)
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({ id }) => ({ type: "Routes", id } as const)),
            { type: "Routes", id: "LIST" }
          ];
        } else {
          return [{ type: "Routes", id: "LIST" }];
        }
      }
    }),
    getRoute: builder.query<Route, string>({
      query: (id) => ({
        url: `/routes/${id}`,
        method: "GET",
        params: buildParams()
      }),
      providesTags: (result, error, id) => [{ type: "Routes", id }]
    })
  })
});

const buildParams = (regionId?: string) => {
  const extrasParams = {
    withCompany: true,
    withSites: false,
    withRegion: true,
    withAssignedPersons: false,
    withRouteGroup: true,
  }

  if (regionId) {
    return {
      regionId: regionId,
      ...extrasParams
    }
  } else {
    return extrasParams
  }
}

export const {
  useGetAllRoutesQuery,
  useGetRouteQuery
} = routeApi;
